import { AfterContentInit, Component } from '@angular/core';

@Component({
    selector: 'app-modal',
    templateUrl: './modal.component.html',
    standalone: false
})
export class ModalComponent implements AfterContentInit {
  ngAfterContentInit(): void {
    let modal = document.getElementById("modal");
    let btn = document.getElementById("open-btn");
    let button = document.getElementById("ok-btn");
    btn.onclick = function () {
      modal.style.display = "block";
    }

    button.onclick = function () {
      modal.style.display = "none";
    }
    window.onclick = function (event) {
      if (event.target == modal) {
        modal.style.display = "none";
      }
    }
  }
}
